// extracted by mini-css-extract-plugin
module.exports = {"Cognito":"Cognito_Cognito__3X10o","Form":"Cognito_Form__3h6KO","Row":"Cognito_Row__3eFsn","Label":"Cognito_Label__27xsr","Select":"Cognito_Select__93aEg"};